import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { LoadingButton } from '../utils';

interface Props {
  labName: string;
  dropoffName: string;
  shipMethod: string;
  onSwitchToCourierClick: () => void;
  children: React.ReactNode;
}

export const ShippingGroupCardsContainer: React.FC<Props> = ({
  labName,
  onSwitchToCourierClick,
  shipMethod,
  children,
}) => {
  return (
    <Box p={2} width={'100%'}>
      {/* Header */}
      {shipMethod === 'UPS' && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
          <Typography variant="h6">{labName}</Typography>

          <LoadingButton onClick={onSwitchToCourierClick} color="secondary" size="small">
            Switch to Courier
          </LoadingButton>
        </Box>
      )}
      <Grid container spacing={2} justifyContent="center" size={12}>
        {React.Children.map(children, (child) => (
          <Grid>{child}</Grid>
        ))}
      </Grid>
    </Box>
  );
};
